import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FontIcon, Link } from '@fluentui/react';
/**
 * Enhances Fluent UI’s `Link` component to include props for opening in a
 * new browser window/tab.
 */
const ExternalLink = (props) => {
    const { children } = props, rest = __rest(props, ["children"]);
    return (_jsxs(Link, Object.assign({}, rest, { rel: 'noopener noreferrer', target: '_blank' }, { children: [children, ' ', _jsx(FontIcon, { "aria-label": 'Opens in new tab', iconName: 'NavigateExternalInline' })] })));
};
// Exports
// -------
export { ExternalLink };
